import { useState } from "react";
import { motion } from "framer-motion";

import { AppWrap } from "./../../HOC/AppWrap";
import { MotionWrap } from "./../../HOC/MotionWrap";
import images from "../../../constants/images";

import "./About.scss";

const About = () => {
  const [abouts] = useState([
    {
      title: "Desarrollo Web",
      description:
        "Realizo trabajos como templates, landings pages, web apps y servidores.",
      imgUrl: images.about01,
    },
    {
      title: "Desarrollo Frontend",
      description:
        "Me enfoco solamente de la UI, usando tecnología como CSR/SSR/SPA o landings.",
      imgUrl: images.about02,
    },
    {
      title: "Animaciones Web",
      description:
        "Siempre damos ese toque de animación en las interfaces, usando Framer Motion o Animate Css.",
      imgUrl: images.about04,
    },
    // {
    //   title: "UI/UX",
    //   description: "I am a good web developer.",
    //   imgUrl: images.about03,
    // },
  ]);

  return (
    <>
      <h2 className="head-text">
        Sé que las &nbsp;
        <span>buenas aplicaciones &nbsp;</span>
        <br />
        Significa &nbsp;
        <span>buen negocio</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <>
            <motion.div
              key={index}
              whileInView={{ opacity: 1 }}
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: "tween" }}
              className="app__profile-item"
            >
              <img src={about.imgUrl} alt={about.title} />
              <h2 className="bold-text" style={{ marginTop: 20 }}>
                {about.title}
              </h2>
              <p className="p-text" style={{ marginTop: 10 }}>
                {about.description}
              </p>
            </motion.div>
          </>
        ))}
      </div>
    </>
  );
};

export default AppWrap(MotionWrap(About, "app__about"), "about");
